import React from 'react';
import { Link } from 'react-router-dom';

const ReadMore = ({ href, title, alt, asA, target="_blank", rel="noreferrer" }) => {

  if (asA) {
    return (
      <div>
        <a  alt={alt || ""} href={href || ''} className="readMore" target={target} rel={rel}>
          {title || 'READ MORE'} >
        </a>
      </div>
    )
  }

  return (
    <div>
      <Link  alt={alt || ""} to={href || ''} className="readMore">
        {title || 'READ MORE'} >
      </Link>
    </div>
  )
}

export default ReadMore;
